import { useCSS } from './use-css';

// Hides the ZenDesk help button in lower left of page
export function useHideZendeskButton(hidden = true) {
  useCSS(
    hidden
      ? 'iframe#launcher[title*="more information"] { display: none !important; }'
      : null
  );
}
